import React from 'react';
import { useSelector } from 'react-redux';
import { RootReducersState } from 'redux/reducers';
import commonService from 'utils/commonService';
import { IProps } from './types';

const MobileDevice:React.FC<IProps> = (props) => {
  const resources = useSelector((state: RootReducersState) => state.resources);

  return (
    <div className="mobile-device-info">
      <div className="mobile-device-info__title">{commonService.getNameByLng(resources, 'TID_Mobile_device_data')}</div>
      <div className="mobile-device-info__content">
        <div className="element__list">
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Device_type')}</div>
              <div className="element__list-group-content">{props.DEVICE_TYPE_NAME}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Device_brand')}</div>
              <div className="element__list-group-content">{props.VENDOR_NAME}</div>
            </div>
          </div>
          <div className={'element__list-col' + (resources.lng === 'en' ? ' element__list-col--full' : '')}>
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Device_model')}</div>
              <div className="element__list-group-content">{props.MODEL}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Device_capacity_GB')}</div>
              <div className="element__list-group-content">{props.STORAGE_SIZE}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_IMEI_code')}</div>
              <div className="element__list-group-content">{props.IMEI_SN}</div>
            </div>
          </div>
          <div className={'element__list-col' + (resources.lng === 'en' ? ' element__list-col--full' : '')}>
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Phone_number_of_the_device')}</div>
              <div className="element__list-group-content">{props.TARGET_PHONE_NO}</div>
            </div>
          </div>
          <div className={'element__list-col' + (resources.lng === 'en' ? ' element__list-col--full' : '')}>
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Price_of_the_device')}</div>
              <div className="element__list-group-content">NT$ {props.MPRICE}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileDevice;
